import { $t } from '../../composables/i18n'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'
import { CountryId } from '../country/CountryId'

export enum ElectronicPaymentTypeId {
  VISA = 1,
  VISA_ELECTRON = 2,
  MAESTRO = 3,
  EURO_CARD_MASTER_CARD = 4,
  AMERICAN_EXPRESS = 5,
  DINERS_CLUB = 6,
  DINERS_CLUB_ENROUTE = 7,
  DINERS_CLUB_CARTE_BLANCHE = 8,
  DISCOVER = 9,
  JCB = 10,
  SOLO = 11,
  SWITCH = 12,
  CS = 13,
  CCS = 14,
  SPHERE = 15,
  GWC = 16,
  OTP_SZEP_KARTYA_VENDEGLATAS = 17,
  MBH_SZEP_KARTYA_VENDEGLATAS = 18,
  KAH_SZEP_KARTYA_VENDEGLATAS = 19,
  OTP_SZEP_KARTYA_SZABADIDO = 20,
  MBH_SZEP_KARTYA_SZABADIDO = 21,
  KAH_SZEP_KARTYA_SZABADIDO = 22,
  OTP_SZEP_KARTYA_SZALLASHELY = 23,
  MBH_SZEP_KARTYA_SZALLASHELY = 24,
  KAH_SZEP_KARTYA_SZALLASHELY = 25,
  BLIK = 26,
  SODEXO_MULTI_PASS = 27,
  EDENRED = 28,
  E_STRAVENKA_UP = 29,
  LEMON_PAY_CARD = 30,
  BENEFIT_PLUS = 31,
  BENEFITKA = 32,
  GASTRO_CARD = 33,
  BESTERON = 34,
  CSOB = 35,
  E_SERVICE = 36,
  FIRST_DATA = 37,
  GO_PAY = 38,
  GP_WEB_PAY = 39,
  CRYPTOCURRENCY = 40,
  PAY_PAL = 41,
  REVOLUT = 42,
  SIMPLE_PAY = 43,
  STRIPE = 44,
  COMGATE = 45,
  SAFERPAY = 46,
  OTP_SZEP_KARTYA = 47,
  MBH_SZEP_KARTYA = 48,
  KAH_SZEP_KARTYA = 49,
  CAFETERIE_BENEFITY = 50,
  GALLERY_BETA = 51,
  UNION_PAY = 52,
  KAH_SZEP_KARTYA_GP_WEB_PAY = 53,
  MBH_SZEP_KARTYA_GP_WEB_PAY = 54,
  OTP_SZEP_KARTYA_GP_WEB_PAY = 55,
  PLUXEE = 56,
  UP = 57,
  APPLE_PAY = 58,
  GOOGLE_PAY = 59,
  GIROCARD = 60,
}

export class ElectronicPaymentType {
  static readonly VISA = new ElectronicPaymentType(ElectronicPaymentTypeId.VISA, 'VISA', [
    CountryId.SVK,
  ])
  static readonly VISA_ELECTRON = new ElectronicPaymentType(
    ElectronicPaymentTypeId.VISA_ELECTRON,
    'Visa Electron',
    [CountryId.SVK],
  )
  static readonly MAESTRO = new ElectronicPaymentType(ElectronicPaymentTypeId.MAESTRO, 'Maestro', [
    CountryId.SVK,
  ])
  static readonly EURO_CARD_MASTER_CARD = new ElectronicPaymentType(
    ElectronicPaymentTypeId.EURO_CARD_MASTER_CARD,
    'EuroCard/MasterCard',
    [CountryId.SVK],
  )
  static readonly AMERICAN_EXPRESS = new ElectronicPaymentType(
    ElectronicPaymentTypeId.AMERICAN_EXPRESS,
    'American Express',
    [CountryId.SVK],
  )
  static readonly DINERS_CLUB = new ElectronicPaymentType(
    ElectronicPaymentTypeId.DINERS_CLUB,
    'Diners Club',
    [CountryId.SVK],
  )
  static readonly DINERS_CLUB_ENROUTE = new ElectronicPaymentType(
    ElectronicPaymentTypeId.DINERS_CLUB_ENROUTE,
    'Diners Club Enroute',
    [CountryId.SVK],
  )
  static readonly DINERS_CLUB_CARTE_BLANCHE = new ElectronicPaymentType(
    ElectronicPaymentTypeId.DINERS_CLUB_CARTE_BLANCHE,
    'Diners Club Carte Blanche',
    [CountryId.SVK],
  )
  static readonly DISCOVER = new ElectronicPaymentType(
    ElectronicPaymentTypeId.DISCOVER,
    'Discover',
    [CountryId.SVK],
  )
  static readonly JCB = new ElectronicPaymentType(ElectronicPaymentTypeId.JCB, 'JCB', [
    CountryId.SVK,
  ])
  static readonly SOLO = new ElectronicPaymentType(ElectronicPaymentTypeId.SOLO, 'Solo', [
    CountryId.SVK,
  ])
  static readonly SWITCH = new ElectronicPaymentType(ElectronicPaymentTypeId.SWITCH, 'Switch', [
    CountryId.SVK,
  ])
  static readonly CS = new ElectronicPaymentType(ElectronicPaymentTypeId.CS, 'CS', [CountryId.SVK])
  static readonly CCS = new ElectronicPaymentType(ElectronicPaymentTypeId.CCS, 'CCS', [
    CountryId.SVK,
  ])
  static readonly SPHERE = new ElectronicPaymentType(ElectronicPaymentTypeId.SPHERE, 'Sphere', [
    CountryId.SVK,
  ])
  static readonly GWC = new ElectronicPaymentType(ElectronicPaymentTypeId.GWC, 'GWC', [
    CountryId.SVK,
  ])
  static readonly OTP_SZEP_KARTYA_VENDEGLATAS = new ElectronicPaymentType(
    ElectronicPaymentTypeId.OTP_SZEP_KARTYA_VENDEGLATAS,
    'OTP SZÉP kártya vendéglátás',
    [CountryId.HUN],
  )
  static readonly MBH_SZEP_KARTYA_VENDEGLATAS = new ElectronicPaymentType(
    ElectronicPaymentTypeId.MBH_SZEP_KARTYA_VENDEGLATAS,
    'MBH SZÉP kártya vendéglátás',
    [CountryId.HUN],
  )
  static readonly KAH_SZEP_KARTYA_VENDEGLATAS = new ElectronicPaymentType(
    ElectronicPaymentTypeId.KAH_SZEP_KARTYA_VENDEGLATAS,
    'K&H SZÉP kártya vendéglátás',
    [CountryId.HUN],
  )
  static readonly OTP_SZEP_KARTYA_SZABADIDO = new ElectronicPaymentType(
    ElectronicPaymentTypeId.OTP_SZEP_KARTYA_SZABADIDO,
    'OTP SZÉP kártya szabadidő',
    [CountryId.HUN],
  )
  static readonly MBH_SZEP_KARTYA_SZABADIDO = new ElectronicPaymentType(
    ElectronicPaymentTypeId.MBH_SZEP_KARTYA_SZABADIDO,
    'MBH SZÉP kártya szabadidő',
    [CountryId.HUN],
  )
  static readonly KAH_SZEP_KARTYA_SZABADIDO = new ElectronicPaymentType(
    ElectronicPaymentTypeId.KAH_SZEP_KARTYA_SZABADIDO,
    'K&H SZÉP kártya szabadidő',
    [CountryId.HUN],
  )
  static readonly OTP_SZEP_KARTYA_SZALLASHELY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.OTP_SZEP_KARTYA_SZALLASHELY,
    'OTP SZÉP kártya szálláshely',
    [CountryId.HUN],
  )
  static readonly MBH_SZEP_KARTYA_SZALLASHELY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.MBH_SZEP_KARTYA_SZALLASHELY,
    'MBH SZÉP kártya szálláshely',
    [CountryId.HUN],
  )
  static readonly KAH_SZEP_KARTYA_SZALLASHELY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.KAH_SZEP_KARTYA_SZALLASHELY,
    'K&H SZÉP kártya szálláshely',
    [CountryId.HUN],
  )
  static readonly BLIK = new ElectronicPaymentType(ElectronicPaymentTypeId.BLIK, 'Blik', [
    CountryId.POL,
  ])
  static readonly SODEXO_MULTI_PASS = new ElectronicPaymentType(
    ElectronicPaymentTypeId.SODEXO_MULTI_PASS,
    'Sodexo Multi Pass',
    [CountryId.CZE, CountryId.SVK],
  )
  static readonly EDENRED = new ElectronicPaymentType(ElectronicPaymentTypeId.EDENRED, 'Edenred', [
    CountryId.CZE,
    CountryId.SVK,
    CountryId.ROU,
  ])
  static readonly E_STRAVENKA_UP = new ElectronicPaymentType(
    ElectronicPaymentTypeId.E_STRAVENKA_UP,
    'eStravenka (UP)',
    [CountryId.CZE, CountryId.SVK],
  )
  static readonly LEMON_PAY_CARD = new ElectronicPaymentType(
    ElectronicPaymentTypeId.LEMON_PAY_CARD,
    'LemonPay card',
    [CountryId.CZE, CountryId.SVK],
  )
  static readonly BENEFIT_PLUS = new ElectronicPaymentType(
    ElectronicPaymentTypeId.BENEFIT_PLUS,
    'Benefit Plus',
    [CountryId.CZE, CountryId.SVK],
  )
  static readonly BENEFITKA = new ElectronicPaymentType(
    ElectronicPaymentTypeId.BENEFITKA,
    'Benefitka',
    [CountryId.CZE, CountryId.SVK],
  )
  static readonly GASTRO_CARD = new ElectronicPaymentType(
    ElectronicPaymentTypeId.GASTRO_CARD,
    'GastroCard',
    [CountryId.CZE, CountryId.SVK],
  )
  static readonly BESTERON = new ElectronicPaymentType(
    ElectronicPaymentTypeId.BESTERON,
    'Besteron',
    [CountryId.CZE, CountryId.SVK],
  )
  static readonly CSOB = new ElectronicPaymentType(ElectronicPaymentTypeId.CSOB, 'ČSOB', [
    CountryId.CZE,
  ])
  static readonly E_SERVICE = new ElectronicPaymentType(
    ElectronicPaymentTypeId.E_SERVICE,
    'eService',
    [CountryId.SVK],
  )
  static readonly FIRST_DATA = new ElectronicPaymentType(
    ElectronicPaymentTypeId.FIRST_DATA,
    'FirstData',
    [CountryId.POL],
  )
  static readonly GO_PAY = new ElectronicPaymentType(ElectronicPaymentTypeId.GO_PAY, 'GoPay', [
    CountryId.CZE,
  ])
  static readonly GP_WEB_PAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.GP_WEB_PAY,
    'GP WebPay',
    [CountryId.HUN, CountryId.CZE],
  )
  static readonly CRYPTOCURRENCY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.CRYPTOCURRENCY,
    $t('Cryptocurrency'),
    [CountryId.SVK],
  )
  static readonly PAY_PAL = new ElectronicPaymentType(ElectronicPaymentTypeId.PAY_PAL, 'PayPal', [
    CountryId.SVK,
  ])
  static readonly REVOLUT = new ElectronicPaymentType(ElectronicPaymentTypeId.REVOLUT, 'Revolut', [
    CountryId.SVK,
  ])
  static readonly SIMPLE_PAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.SIMPLE_PAY,
    'Simple pay',
    [CountryId.HUN],
  )
  static readonly STRIPE = new ElectronicPaymentType(ElectronicPaymentTypeId.STRIPE, 'Stripe', [
    CountryId.SVK,
  ])
  static readonly COMGATE = new ElectronicPaymentType(ElectronicPaymentTypeId.COMGATE, 'Comgate', [
    CountryId.CZE,
    CountryId.SVK,
  ])
  static readonly SAFERPAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.SAFERPAY,
    'Saferpay',
    [CountryId.SVK],
  )
  static readonly OTP_SZEP_KARTYA = new ElectronicPaymentType(
    ElectronicPaymentTypeId.OTP_SZEP_KARTYA,
    'OTP SZÉP kártya',
    [CountryId.HUN],
  )
  static readonly MBH_SZEP_KARTYA = new ElectronicPaymentType(
    ElectronicPaymentTypeId.MBH_SZEP_KARTYA,
    'MBH SZÉP kártya',
    [CountryId.HUN],
  )
  static readonly KAH_SZEP_KARTYA = new ElectronicPaymentType(
    ElectronicPaymentTypeId.KAH_SZEP_KARTYA,
    'K&H SZÉP kártya',
    [CountryId.HUN],
  )
  static readonly CAFETERIE_BENEFITY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.CAFETERIE_BENEFITY,
    'Cafeterie Benefity',
    [CountryId.CZE],
  )
  static readonly GALLERY_BETA = new ElectronicPaymentType(
    ElectronicPaymentTypeId.GALLERY_BETA,
    'Gallery Beta',
    [CountryId.CZE],
  )
  static readonly UNION_PAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.UNION_PAY,
    'UnionPay',
    [CountryId.SVK],
  )
  static readonly KAH_SZEP_KARTYA_GP_WEB_PAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.KAH_SZEP_KARTYA_GP_WEB_PAY,
    'K&H SZÉP kártya GP WebPay',
    [CountryId.HUN],
  )
  static readonly MBH_SZEP_KARTYA_GP_WEB_PAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.MBH_SZEP_KARTYA_GP_WEB_PAY,
    'MBH SZÉP kártya GP WebPay',
    [CountryId.HUN],
  )
  static readonly OTP_SZEP_KARTYA_GP_WEB_PAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.OTP_SZEP_KARTYA_GP_WEB_PAY,
    'OTP SZÉP kártya GP WebPay',
    [CountryId.HUN],
  )
  static readonly PLUXEE = new ElectronicPaymentType(ElectronicPaymentTypeId.PLUXEE, 'Pluxee', [
    CountryId.ROU,
    CountryId.CZE,
  ])
  static readonly UP = new ElectronicPaymentType(ElectronicPaymentTypeId.UP, 'Up', [CountryId.ROU])
  static readonly APPLE_PAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.APPLE_PAY,
    'Apple Pay',
    [CountryId.SVK],
  )
  static readonly GOOGLE_PAY = new ElectronicPaymentType(
    ElectronicPaymentTypeId.GOOGLE_PAY,
    'Google Pay',
    [CountryId.SVK],
  )
  static readonly GIROCARD = new ElectronicPaymentType(
    ElectronicPaymentTypeId.GIROCARD,
    'Girocard',
    [CountryId.SVK],
  )

  private constructor(
    public readonly id: ElectronicPaymentTypeId,
    public readonly name: string,
    public readonly countryIds: CountryId[],
  ) {}

  static getById = (id: ElectronicPaymentTypeId): ElectronicPaymentType => {
    const value = ElectronicPaymentType.all().find((item: ElectronicPaymentType) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(ElectronicPaymentType.name, id)
    }

    return value
  }

  static getAllowedByHotelAndByCountryId = (
    allowedElectronicPaymentTypes: ElectronicPaymentType[],
    countryId: CountryId,
  ): ElectronicPaymentType[] => {
    if (allowedElectronicPaymentTypes.length > 0) {
      return allowedElectronicPaymentTypes
    }

    return ElectronicPaymentType.all().filter(
      (item) => item.countryIds.includes(countryId) || item.countryIds.length === 0,
    )
  }

  static getByCountryId = (countryId: CountryId): ElectronicPaymentType[] => {
    return ElectronicPaymentType.all().filter(
      (item) => item.countryIds.includes(countryId) || item.countryIds.length === 0,
    )
  }

  static getPaymentCardsByCountryId = (countryId: CountryId): ElectronicPaymentType[] => {
    return ElectronicPaymentType.getPaymentCards().filter(
      (item) => item.countryIds.includes(countryId) || item.countryIds.length === 0,
    )
  }

  static getOnlinePaymentsByCountryId = (countryId: CountryId): ElectronicPaymentType[] => {
    return ElectronicPaymentType.getOnlinePayments().filter(
      (item) => item.countryIds.includes(countryId) || item.countryIds.length === 0,
    )
  }

  static getMealVoucherAndBenefitCardsByCountryId = (
    countryId: CountryId,
  ): ElectronicPaymentType[] => {
    return ElectronicPaymentType.getMealVoucherAndBenefitCards().filter(
      (item) => item.countryIds.includes(countryId) || item.countryIds.length === 0,
    )
  }

  static all = (): ElectronicPaymentType[] => {
    return [
      ElectronicPaymentType.VISA,
      ElectronicPaymentType.VISA_ELECTRON,
      ElectronicPaymentType.MAESTRO,
      ElectronicPaymentType.EURO_CARD_MASTER_CARD,
      ElectronicPaymentType.AMERICAN_EXPRESS,
      ElectronicPaymentType.DINERS_CLUB,
      ElectronicPaymentType.DINERS_CLUB_ENROUTE,
      ElectronicPaymentType.DINERS_CLUB_CARTE_BLANCHE,
      ElectronicPaymentType.DISCOVER,
      ElectronicPaymentType.JCB,
      ElectronicPaymentType.SOLO,
      ElectronicPaymentType.SWITCH,
      ElectronicPaymentType.CS,
      ElectronicPaymentType.CCS,
      ElectronicPaymentType.SPHERE,
      ElectronicPaymentType.GWC,
      ElectronicPaymentType.OTP_SZEP_KARTYA_VENDEGLATAS,
      ElectronicPaymentType.MBH_SZEP_KARTYA_VENDEGLATAS,
      ElectronicPaymentType.KAH_SZEP_KARTYA_VENDEGLATAS,
      ElectronicPaymentType.OTP_SZEP_KARTYA_SZABADIDO,
      ElectronicPaymentType.MBH_SZEP_KARTYA_SZABADIDO,
      ElectronicPaymentType.KAH_SZEP_KARTYA_SZABADIDO,
      ElectronicPaymentType.OTP_SZEP_KARTYA_SZALLASHELY,
      ElectronicPaymentType.MBH_SZEP_KARTYA_SZALLASHELY,
      ElectronicPaymentType.KAH_SZEP_KARTYA_SZALLASHELY,
      ElectronicPaymentType.BLIK,
      ElectronicPaymentType.SODEXO_MULTI_PASS,
      ElectronicPaymentType.EDENRED,
      ElectronicPaymentType.E_STRAVENKA_UP,
      ElectronicPaymentType.LEMON_PAY_CARD,
      ElectronicPaymentType.BENEFIT_PLUS,
      ElectronicPaymentType.BENEFITKA,
      ElectronicPaymentType.GASTRO_CARD,
      ElectronicPaymentType.BESTERON,
      ElectronicPaymentType.CSOB,
      ElectronicPaymentType.E_SERVICE,
      ElectronicPaymentType.FIRST_DATA,
      ElectronicPaymentType.GO_PAY,
      ElectronicPaymentType.GP_WEB_PAY,
      ElectronicPaymentType.CRYPTOCURRENCY,
      ElectronicPaymentType.PAY_PAL,
      ElectronicPaymentType.REVOLUT,
      ElectronicPaymentType.SIMPLE_PAY,
      ElectronicPaymentType.STRIPE,
      ElectronicPaymentType.COMGATE,
      ElectronicPaymentType.SAFERPAY,
      ElectronicPaymentType.OTP_SZEP_KARTYA,
      ElectronicPaymentType.MBH_SZEP_KARTYA,
      ElectronicPaymentType.KAH_SZEP_KARTYA,
      ElectronicPaymentType.CAFETERIE_BENEFITY,
      ElectronicPaymentType.GALLERY_BETA,
      ElectronicPaymentType.UNION_PAY,
      ElectronicPaymentType.KAH_SZEP_KARTYA_GP_WEB_PAY,
      ElectronicPaymentType.MBH_SZEP_KARTYA_GP_WEB_PAY,
      ElectronicPaymentType.OTP_SZEP_KARTYA_GP_WEB_PAY,
      ElectronicPaymentType.PLUXEE,
      ElectronicPaymentType.UP,
      ElectronicPaymentType.APPLE_PAY,
      ElectronicPaymentType.GOOGLE_PAY,
      ElectronicPaymentType.GIROCARD,
    ]
  }

  static getPaymentCards = (): ElectronicPaymentType[] => {
    return [
      ElectronicPaymentType.AMERICAN_EXPRESS,
      ElectronicPaymentType.CCS,
      ElectronicPaymentType.CS,
      ElectronicPaymentType.DINERS_CLUB,
      ElectronicPaymentType.DINERS_CLUB_CARTE_BLANCHE,
      ElectronicPaymentType.DINERS_CLUB_ENROUTE,
      ElectronicPaymentType.DISCOVER,
      ElectronicPaymentType.EURO_CARD_MASTER_CARD,
      ElectronicPaymentType.GIROCARD,
      ElectronicPaymentType.GWC,
      ElectronicPaymentType.JCB,
      ElectronicPaymentType.OTP_SZEP_KARTYA_VENDEGLATAS,
      ElectronicPaymentType.MBH_SZEP_KARTYA_VENDEGLATAS,
      ElectronicPaymentType.KAH_SZEP_KARTYA_VENDEGLATAS,
      ElectronicPaymentType.OTP_SZEP_KARTYA_SZABADIDO,
      ElectronicPaymentType.MBH_SZEP_KARTYA_SZABADIDO,
      ElectronicPaymentType.KAH_SZEP_KARTYA_SZABADIDO,
      ElectronicPaymentType.OTP_SZEP_KARTYA_SZALLASHELY,
      ElectronicPaymentType.MBH_SZEP_KARTYA_SZALLASHELY,
      ElectronicPaymentType.KAH_SZEP_KARTYA_SZALLASHELY,
      ElectronicPaymentType.KAH_SZEP_KARTYA,
      ElectronicPaymentType.MAESTRO,
      ElectronicPaymentType.MBH_SZEP_KARTYA,
      ElectronicPaymentType.OTP_SZEP_KARTYA,
      ElectronicPaymentType.SOLO,
      ElectronicPaymentType.SPHERE,
      ElectronicPaymentType.SWITCH,
      ElectronicPaymentType.UNION_PAY,
      ElectronicPaymentType.VISA,
      ElectronicPaymentType.VISA_ELECTRON,
    ]
  }

  static getOnlinePayments = (): ElectronicPaymentType[] => {
    return [
      ElectronicPaymentType.APPLE_PAY,
      ElectronicPaymentType.BESTERON,
      ElectronicPaymentType.COMGATE,
      ElectronicPaymentType.CRYPTOCURRENCY,
      ElectronicPaymentType.CSOB,
      ElectronicPaymentType.E_SERVICE,
      ElectronicPaymentType.GOOGLE_PAY,
      ElectronicPaymentType.GO_PAY,
      ElectronicPaymentType.GP_WEB_PAY,
      ElectronicPaymentType.PAY_PAL,
      ElectronicPaymentType.REVOLUT,
      ElectronicPaymentType.SAFERPAY,
      ElectronicPaymentType.SIMPLE_PAY,
      ElectronicPaymentType.STRIPE,
      ElectronicPaymentType.KAH_SZEP_KARTYA_GP_WEB_PAY,
      ElectronicPaymentType.MBH_SZEP_KARTYA_GP_WEB_PAY,
      ElectronicPaymentType.OTP_SZEP_KARTYA_GP_WEB_PAY,
    ]
  }

  static getMealVoucherAndBenefitCards = (): ElectronicPaymentType[] => {
    return [
      ElectronicPaymentType.BENEFIT_PLUS,
      ElectronicPaymentType.BENEFITKA,
      ElectronicPaymentType.CAFETERIE_BENEFITY,
      ElectronicPaymentType.EDENRED,
      ElectronicPaymentType.E_STRAVENKA_UP,
      ElectronicPaymentType.GALLERY_BETA,
      ElectronicPaymentType.GASTRO_CARD,
      ElectronicPaymentType.LEMON_PAY_CARD,
      ElectronicPaymentType.PLUXEE,
      ElectronicPaymentType.SODEXO_MULTI_PASS,
      ElectronicPaymentType.UP,
    ]
  }
}
